import React from "react";
import { ShieldCheck, Compass, SearchCheck, Target, Wrench, FileCheck, RefreshCw, Building2, Link2 } from "lucide-react";
import { DashboardPreview } from "./DashboardPreview";
import "./login-hero.css";

const JOURNEY_STEPS = [
  { icon: Compass, label: "Discover" },
  { icon: SearchCheck, label: "Assess" },
  { icon: Target, label: "Prioritise" },
  { icon: Wrench, label: "Remediate" },
  { icon: FileCheck, label: "Evidence" },
];

const TRUST_METRICS = [
  { icon: RefreshCw, value: "360°", label: "Compliance View", id: "compliance-view" },
  { icon: ShieldCheck, value: "90", label: "Controls Tracked", id: "controls-tracked" },
  { icon: Building2, value: "15", label: "Compliance Pillars Covered", id: "pillars-covered" },
];

export const LoginHero = () => (
  <section className="login-hero order-2 lg:order-1 lg:w-[60%]" data-testid="login-hero">
    <div className="login-hero-layout">
      <div className="login-brand" data-testid="login-brand">
        <ShieldCheck size={48} strokeWidth={1.5} aria-hidden="true" />
        <div>
          <div className="login-brand-name" data-testid="login-brand-name">CX0 DPDP Tracker</div>
          <div className="login-brand-tagline" data-testid="login-brand-tagline">DPDP. Simplified.</div>
        </div>
      </div>

      <h1 className="login-hero-heading" data-testid="login-hero-heading">
        Your DPDP<br /><span>command center.</span>
      </h1>

      <p className="login-hero-copy" data-testid="login-hero-copy">
        All in one workspace integrated with{" "}
        <a href="https://dpdp.codexero.ai" target="_blank" rel="noopener noreferrer" data-testid="dpdp-platform-link">
          CX0 DPDP Platform.
        </a>
      </p>

      <DashboardPreview />

      <div className="login-journey" data-testid="journey-stepper">
        {JOURNEY_STEPS.map(({ icon: Icon, label }, i) => (
          <div key={label} className="login-journey-step login-fade" style={{ animationDelay: `${i * 80}ms` }} data-testid={`journey-step-${label.toLowerCase()}`}>
            <div className="login-journey-icon"><Icon size={24} aria-hidden="true" /></div>
            <span>{label}</span>
          </div>
        ))}
      </div>

      <div className="login-trust-strip" data-testid="trust-strip">
        {TRUST_METRICS.map(({ icon: Icon, value, label, id }, i) => (
          <div key={id} className="login-trust-metric login-fade" style={{ animationDelay: `${i * 100}ms` }} data-testid={`trust-metric-${id}`}>
            <div className="login-trust-value"><Icon size={30} strokeWidth={1.5} aria-hidden="true" /><span>{value}</span></div>
            <span className="login-trust-label">{label}</span>
          </div>
        ))}
      </div>

      <div className="login-hero-footer" data-testid="login-footer-row">
        <div className="login-platform-credit" data-testid="login-platform-credit">
          <Link2 size={17} aria-hidden="true" />
          <span>Powered by <strong>CX0 DPDP Platform</strong></span>
        </div>
        <div className="login-origin" data-testid="login-origin">
          <svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true">
            <rect width="18" height="4" fill="#FF9933" />
            <rect y="4" width="18" height="4" fill="#FFFFFF" />
            <rect y="8" width="18" height="4" fill="#138808" />
            <circle cx="9" cy="6" r="1.5" fill="none" stroke="#000080" strokeWidth="0.4" />
          </svg>
          <span>Made in India</span>
        </div>
      </div>
    </div>
  </section>
);